module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG39fb3a8bcf7a3a83ebb7a672d39637b5.39fb3a8b.png";